import { useTranslation } from "react-i18next";
import { useLocale, useSetLocale, type Locale } from "@/shared/store/locale";

export function useT(): ReturnType<typeof useTranslation> {
  return useTranslation();
}

export function useCurrentLocale(): Locale {
  return useLocale();
}

export function useChangeLocale(): (l: Locale) => void {
  return useSetLocale();
}
